import { render, staticRenderFns } from "./InterpretationValidateForm.vue?vue&type=template&id=263c2d96&"
import script from "./InterpretationValidateForm.vue?vue&type=script&lang=js&"
export * from "./InterpretationValidateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports